import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-B70johtp.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--ar-AE" */'./ar-AE-6s5-oCrR.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--de-DE" */'./de-DE-D3-fppnJ.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--en-AU" */'./en-AU-DDntuMZl.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--en-CA" */'./en-CA-D4vDHJrC.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--en-GB" */'./en-GB-C354pKq3.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--en-IN" */'./en-IN-DofqFRzH.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--en-SG" */'./en-SG-Dl2hBLSR.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--es-CO" */'./es-CO-CkTdyzkU.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--es-ES" */'./es-ES-kkwjCyN8.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--es-MX" */'./es-MX-CqIMlLe9.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--fr-CA" */'./fr-CA-BsdN5-vE.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--fr-FR" */'./fr-FR-BiKyCMHo.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--hi-IN" */'./hi-IN-BCCxX9Uy.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--it-IT" */'./it-IT-BYeVAHIR.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--ja-JP" */'./ja-JP-CiTIIvgx.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--ko-KR" */'./ko-KR-DaielxxT.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--nl-NL" */'./nl-NL-DWCSjhJX.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--pl-PL" */'./pl-PL-CfWn9Toq.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--pt-BR" */'./pt-BR-BYoR4l72.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--sv-SE" */'./sv-SE-Dt3SHcX9.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--ta-IN" */'./ta-IN-C6zFObGE.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--th-TH" */'./th-TH-CSnHNEdo.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--tr-TR" */'./tr-TR-D7_TMZSA.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--vi-VN" */'./vi-VN-CDVMRhtl.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--zh-CN" */'./zh-CN-Ci7enLoh.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui--SummaryCardRow--zh-TW" */'./zh-TW-cOGMWP86.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-D5oLHOIL.js.map
